import Modal from 'components/Modal';
import { Map } from 'immutable';
import { isBoolean } from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

export default class EmailConfirmation extends Component {
  static propTypes = {
    incomingData: PropTypes.instanceOf(Map).isRequired,
    router: PropTypes.object.isRequired,
    updateIncomingData: PropTypes.func.isRequired,
    goToHome: PropTypes.func.isRequired,
  };

  state = {
    show: false,
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { incomingData } = nextProps;
    const data = incomingData.toJS().data || {};

    if (data.checkEmail && this.state.show) {
      return;
    }

    this.setState({
      show: data.email && isBoolean(data.checkEmail),
    });
  }

  onClose = () => {
    const { updateIncomingData, router, goToHome } = this.props;
    this.setState({ show: false });
    updateIncomingData({ checkEmail: null });
    goToHome(router.route);
  };

  render() {
    const { incomingData } = this.props;
    const data = incomingData.toJS().data || {};
    const statusPrefix = data.checkEmail ? '' : 'не ';

    return (
      <Modal
        onClose={() => this.onClose()}
        showModal={this.state.show}
        id="email-confirmation"
        type="large"
      >
        <h2 className="blue">Адрес электронной почты {statusPrefix}подтвержден</h2>
        <div className="link link_attention-red">
          <div className="bold page_margin20">
            Адрес электронной почты {`${data.email} ` || ''}
            {statusPrefix}подтвержден
          </div>
          <a onClick={this.onClose}>Перейти к главной странице</a>
        </div>
      </Modal>
    );
  }
}
